// Copyright (c) 2020 embyt GmbH. All rights reserved.
// Author: Roman Morawek <roman.morawek@embyt.com>

import { IEnergyMeter } from "parameter";
import { isSet, round } from "utils";

class EnergyMeter {
  readonly parameter: IEnergyMeter;
  readonly value: number | undefined;

  constructor(parameter: IEnergyMeter, data: number | undefined) {
    this.parameter = parameter;
    this.value = data;
  }

  public getText(): string {
    if (!isSet(this.value) || isNaN(this.value)) {
      return "-";
    }
    const valueString = round(this.value, 1).toLocaleString();
    return valueString + " " + this.parameter.unit;
  }

  public getValueText(): string {
    if (!isSet(this.value)) {
      return "-";
    }
    const valueString = round(this.value, 1).toLocaleString();
    return valueString;
  }

  public getUnitText(): string {
    return this.parameter.unit;
  }
}

export default EnergyMeter;
